import React, { useEffect, useState } from 'react';
import {toast} from 'react-toastify';
import { useSearchParams } from 'src/utils/useSearchParams'
import { useNavigate } from 'src/utils/useNavigate';
import Button from 'src/components/Button';
import ContentLayout from 'src/components/ContentLayout';
import SBPLogo from 'src/components/SBPLogo';
import Text from 'src/components/Text';
import routes from 'src/constants/routes';
import { postInvitationFromOrganizationAPI } from 'src/serverApi/invitations';
import PageSpin from 'src/components/PageSpin';
import HelpLink from 'src/components/HelpLink';
import LoginForm from './LoginForm';
import PhoneCodeForm from './PhoneCodeForm';
import PasswordForm from './PasswordForm';
import AccountProfileForm from './AccountProfileForm';
import styles from './styles.module.scss';

enum STEPS {
  login = 'login',
  phoneCode = 'phoneCode',
  setPassword = 'setPassword',
  setAccountProfile = 'setAccountProfile',
  success = 'success',
}

const Registration: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const confirmationId = searchParams.get('confirmation');
  
  const [isLoading, setIsLoading] = useState(false);
  const [invitationData, setInvitationData] = useState<any>();
  const [step, setStep] = useState(STEPS.login);
  const [authorizationInfo, setAuthorizationInfo] = useState();
  
  const title = step === STEPS.success ? 'Поздравляем!' : 'Регистрация';
  
  const loadInvitationData = async (confirmationId: any) => {
    try {
      setIsLoading(true);
      const data = await postInvitationFromOrganizationAPI(confirmationId);
      setInvitationData(data);
    } catch (error: any) {
      if (error.type === 'NOT_FOUND') {
        toast.error('Ссылка недействительна. Получите новую ссылку и перейдите по ней.');
        return;
      }
      toast.error('При загрузке данных приглашения произошла ошибка');
    } finally {
      setIsLoading(false);
    }
  };
  
  useEffect(() => {
    if (confirmationId){
      loadInvitationData(confirmationId);
    }
  }, [confirmationId]);
  
  const handleRegistrationStart = (authorizationInfo: any) => {
    setAuthorizationInfo(authorizationInfo);
    setStep(STEPS.phoneCode);
  }
  
  const handlePhoneConfirm = () => {
    setStep(STEPS.setPassword);
  }
  
  const handlePhoneCodeBack = () => {
    setStep(STEPS.login);
  }
  
  const handlePasswordConfirm = () => {
    setStep(STEPS.setAccountProfile);
  }
  
  const handleAccountProfileConfirm = () => {
    setStep(STEPS.success);
  }
  
  const handleSuccessClick = () => {
    navigate(routes.agent);
  }
  
  if (isLoading) {
    return <PageSpin />;
  }
  
  return (
    <ContentLayout size="small">
      <HelpLink className={styles['help']}/>
      <SBPLogo className={styles['sbp-logo']} />
      <Text type="h2" className={styles['title']}>{title}</Text>
      {step === STEPS.login && (
        <LoginForm
          inviteConfirmationId={confirmationId}
          inviteOrganizationUeid={invitationData?.organizationUeid}
          onSubmit={handleRegistrationStart}
        />
      )}
      {step === STEPS.phoneCode && (
        <PhoneCodeForm
          inviteConfirmationId={confirmationId}
          inviteOrganizationUeid={invitationData?.organizationUeid}
          authorizationInfo={authorizationInfo}
          onBack={handlePhoneCodeBack}
          onSubmit={handlePhoneConfirm}
        />
      )}
      {step === STEPS.setPassword && (
        <PasswordForm
          authorizationInfo={authorizationInfo}
          onSubmit={handlePasswordConfirm}
        />
      )}
      {step === STEPS.setAccountProfile && (
        <AccountProfileForm
          onSubmit={handleAccountProfileConfirm}
        />
      )}
      {step === STEPS.success && (
        <>
          <Text type="p" className={styles['text']}>
            Регистрация завершена<br />
            На указанный email отправлено письмо с подтверждением регистрации.
          </Text>
          <div className={styles['button-wrapper']}>
            <Button onClick={handleSuccessClick}>Войти</Button>
          </div>
        </>
      )}
    </ContentLayout>
  );
};

export default Registration;
